<terra-dialog-header [showCloseButton]="data.showCloseIcon">
    <div class="title">
        <div class="pt-2">{{data.title}}</div>
        <div>{{data.subTitle}}</div>
    </div>
</terra-dialog-header>

<mat-dialog-content>
    <ng-template terraAddDynamicComponent></ng-template>
</mat-dialog-content>

<div mat-dialog-actions [ngClass]="data.actionPosition" *ngIf="!data.hideAction">
    <button mat-flat-button color="{{data.actionButtonColor}}" cdkFocusInitial class="action-button"
        (click)="action()">{{ data.actionLabel ? data.actionLabel : 'OK' }}
        <mat-icon *ngIf="data.svgIcon" svgIcon="{{data.svgIcon}}" class="notranslate"></mat-icon>
    </button>
    <button *ngIf="!data.hideCancel" [mat-dialog-close]="false" type="button" mat-button aria-label="Close"
        class="cancel-button">
        {{ data.cancelLabel ? data.cancelLabel : 'Cancel' }}
    </button>
</div>